import baseAppModule from '@framework/store/modules/app'
import routeNames from '@/router/route-names'
import {APP_FOOTER, APP_TITLE} from '@/store/static/base-app'

const baseApp = baseAppModule()

const initialState = () => ({
    ...baseApp.state,
    title: APP_TITLE,
    footer: APP_FOOTER,
    routeNames
})

export default {
    namespaced: true,
    state: initialState(),
    getters: {
        ...baseApp.getters,
        title: state => state.title,
        footer: state => state.footer
    },
    actions: baseApp.actions,
    mutations: baseApp.mutations
}
